import { useEffect } from 'react';
import { RouterBridge } from './router-bridge';
export var useOnAfterRouteChange = function (callback, dependencies) {
    useEffect(function () {
        var unsubscribe = RouterBridge.subscribeOnAfterChange(callback);
        return function () {
            unsubscribe();
        };
    }, dependencies);
};
export var useOnBeforeRouteChange = function (callback, dependencies) {
    useEffect(function () {
        var unsubscribe = RouterBridge.subscribeOnBeforeChange(callback);
        return function () {
            unsubscribe();
        };
    }, dependencies);
};
